import { SemanticColorKey } from 'app/components/v2/theme/colors';

export type IconColor =
  | 'active'
  | 'danger'
  | 'default'
  | 'disabled'
  | 'info'
  | 'neutral'
  | 'status'
  | 'success'
  | 'utility'
  | 'warning'
  | 'white';

type SemanticIconColor = Extract<SemanticColorKey,
  | 'icon_active'
  | 'icon_danger'
  | 'icon_default'
  | 'icon_disabled'
  | 'icon_info'
  | 'icon_neutral'
  | 'icon_success'
  | 'icon_utility'
  | 'icon_warning'
  | 'icon_white'
  | 'status_text'
>;

export const iconColors: Record<IconColor, SemanticIconColor> = {
  active: 'icon_active',
  danger: 'icon_danger',
  default: 'icon_default',
  disabled: 'icon_disabled',
  info: 'icon_info',
  neutral: 'icon_neutral',
  status: 'status_text',
  success: 'icon_success',
  utility: 'icon_utility',
  warning: 'icon_warning',
  white: 'icon_white',
};
